import type { ButtonProps } from '@hover/blueprint';
import React from 'react';

import { useRenderingContext } from 'src/modules/renderings/hooks';
import { Button } from 'src/shared/components';
import { FeatureTracking } from 'src/shared/constants/FeatureFlag';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const CopyLinkButton = (
  props: Omit<ButtonProps, 'fill' | 'shape' | 'color' | 'children'>,
) => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const { trackingData } = useRenderingContext();
  const optionalTrackingProperties = {
    ...trackingData,
    track_id: 'rendering-share-copy-link',
    feature: FeatureTracking.RENDERING,
  };

  return (
    <Button
      {...props}
      color="primary"
      fill="minimal"
      optionalTrackingProperties={optionalTrackingProperties}
      shape="box"
      size={{ base: 'small', tablet: 'large' }}
    >
      {t('renderings.copyLink')}
    </Button>
  );
};

export { CopyLinkButton };
